import { Box } from "@chakra-ui/react";
import { FunctionComponent, ReactNode } from "react";

type GrayDotBoxProps = {
  children?: ReactNode
};

export const GrayDotBox: FunctionComponent<GrayDotBoxProps> = ({ children }) => (
  <Box position="relative">
    <Box
      position="absolute"
      top="35%"
      left="0"
      transform="translateY(-50%)"
      width="12px"
      height="12px"
      bg="brand.gray.700"
    />
    {children}
  </Box>
);